import moment from 'moment'
import React, { useMemo } from 'react'
import type { FC } from 'react'

import HandleRestClickContainer from '../HandleRestClickContainer'

import RestCard from './RestCard/RestCard'

type Props = {
  restId: number
  weeklyscheduleId: number
  day?: string
  isRnd?: boolean
}
const RestCardContainerComponent: FC<Props> = ({
  restId,
  weeklyscheduleId,
  day,
  isRnd = false
}) => {
  const memoizedRestCard = useMemo(() => <RestCard restId={restId} />, [restId])

  if (isRnd) {
    return memoizedRestCard
  }

  return (
    <HandleRestClickContainer
      dataTestId={`rest-card-${moment(day).day()}`}
      weeklyscheduleId={weeklyscheduleId}
      restId={restId}
    >
      <RestCard restId={restId} />
    </HandleRestClickContainer>
  )
}

RestCardContainerComponent.displayName = 'RestCardContainer'
export const RestCardContainer = React.memo(RestCardContainerComponent)
